import type { ComponentProps } from 'react';
import type React from 'react';

import { Image } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useLoadImage } from '#src/app/shared/hooks/image';

const MAX_ATTEMPTS = 10;
const POLLING_TIME = 3 * 1000; // 3sec

type ProgressiveImageProps = Omit<ComponentProps<typeof Image>, 'src'> & {
	alt: string | undefined;
	src: string | undefined;
	preview: string;
};

export const ProgressiveImage: React.FC<ProgressiveImageProps> = ({ alt, src, preview, ...rest }) => {
	const loadedImage = useLoadImage(src, { maxAttempts: MAX_ATTEMPTS, pollingTime: POLLING_TIME });

	return (
		<div className="w-full overflow-hidden rounded-md">
			<Image
				className={cn('block w-full', { 'blur-[20px]': !loadedImage })}
				alt={loadedImage ? alt : ''}
				src={loadedImage ? src : preview}
				{...rest}
			/>
		</div>
	);
};
